import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Grid, Divider, Checkbox, Input, TextArea, Label } from 'semantic-ui-react';

import * as ProductionReportSetupActions from '../state/reports/actions';
import * as ProductionReportSetupSelectors from '../state/selectors';
import { MealTypes, NonOtherMealTypes } from '../helpers/Constants'

class AssignMenuMealTypePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            details: '',
            otherDetails: '',
            reportNotes: '',
        };
      }

    selectMealType = (evt, { value }) => {
        const { setMealType, removeMealType, selectedMealTypes, setMealTypes, setNewReportDetails, setNewReportOtherDetails } = this.props;  
        
        if(value === MealTypes.Other && !_.includes(selectedMealTypes, value)) {
            setMealTypes([MealTypes.Other]);
            setNewReportDetails('');
            return;
        }

        if(_.includes(selectedMealTypes, value)) {
            removeMealType(value);
        } else {
            removeMealType(MealTypes.Other);
            setNewReportOtherDetails('');
            setMealType(value);
        }        
    };

    isDisabled = (values) => {
        const { selectedMealTypes } = this.props; 
        var re = new RegExp(values.join('|'));
        return !re.test(selectedMealTypes);
    }  

    isInvalid = () => {
        const { otherDetails, selectedMealTypes } = this.props; 
        if(_.includes(selectedMealTypes, MealTypes.Other) && otherDetails.length === 0) {
            return true;
        }
        return false;
    }

    render() {
        const { selectedMealTypes, details, otherDetails, reportNotes, setNewReportDetails, setNewReportOtherDetails, setNewReportNotes } = this.props;        

        return (
            <Grid columns={4}>
                <Grid.Row>
                    <Grid.Column width={1}/>

                    <Grid.Column width={4}>
                        <Grid.Row>
                            <Checkbox label="Breakfast" className='large' value={MealTypes.Breakfast} onChange={this.selectMealType} checked={_.includes(selectedMealTypes, MealTypes.Breakfast)}/>
                        </Grid.Row>
                        <Grid.Row>
                            <Checkbox label="Lunch" className='large' value={MealTypes.Lunch} onChange={this.selectMealType} checked={_.includes(selectedMealTypes, MealTypes.Lunch)}/>
                        </Grid.Row>
                        <Grid.Row>
                            <Checkbox label="Salad Bar" className='large' value={MealTypes.SaladBar} onChange={this.selectMealType} checked={_.includes(selectedMealTypes, MealTypes.SaladBar)}/>
                        </Grid.Row>
                        <Grid.Row>
                            <Checkbox label="Snack Bar" className='large' value={MealTypes.SnackBar} onChange={this.selectMealType} checked={_.includes(selectedMealTypes, MealTypes.SnackBar)}/>
                        </Grid.Row>    
                        <Grid.Row>
                            <Checkbox label="Supper" className='large' value={MealTypes.Supper} onChange={this.selectMealType} checked={_.includes(selectedMealTypes, MealTypes.Supper)}/>
                        </Grid.Row>   
                        <Grid.Row>
                            <Input placeholder="Add Details" style={{ width: '100%' }} disabled={this.isDisabled(NonOtherMealTypes)} value={details} onChange={(evt, { value }) => setNewReportDetails(value) } maxLength="25"/>
                        </Grid.Row>                    
                    </Grid.Column>

                    <Grid.Column width={1}>
                        <Divider vertical className='full'/>
                    </Grid.Column>
                    
                    <Grid.Column width={9}>
                        
                        <Grid.Row style={{ height: '24px' }}/>
                        <Grid.Row>
                            <Grid columns={2}>
                                <Grid.Row>
                                    <Grid.Column width={5}>
                                        <Checkbox label="Other *" className='large' style={{ marginTop: '8px' }} value={MealTypes.Other} onChange={this.selectMealType} checked={_.includes(selectedMealTypes, MealTypes.Other)}/>
                                    </Grid.Column>
                                    <Grid.Column width={11}>
                                        <Input placeholder="Add Details" style={{ width: '100%' }} className={`${this.isInvalid() ? 'invalid' : ''}`} disabled={this.isDisabled([MealTypes.Other])} value={otherDetails} onChange={(evt, { value }) => setNewReportOtherDetails(value) } maxLength="25" minLength="1"/>
                                        <Label style={{color: 'red', width: '100%'}} className={`${this.isInvalid() ? '' : 'hidden'}`}>Other Menu/Meal Type is required.</Label>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>                            
                        </Grid.Row>
                        <Grid.Row style={{ height: '16px' }}/>
                        <Grid.Row>
                            <span className={'right floated'}>* Required Field</span>
                        </Grid.Row>
                    </Grid.Column> 

                    <Grid.Column width={1}/>                   
                </Grid.Row>

                <Grid.Row>
                    <Divider />
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={1}/>
                    <Grid.Column width={14}>
                        <label style={{ fontSize: '16px', fontWeight: '400' }}>Report Notes</label>
                    </Grid.Column>                    
                    <Grid.Column width={1}/>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={1}/>
                    <Grid.Column width={14}>
                        <TextArea value={reportNotes} onChange={(evt, { value }) => setNewReportNotes(value) } maxLength="300"/> 
                    </Grid.Column>                                        
                    <Grid.Column width={1}/>
                </Grid.Row>
            </Grid>
        );
    };
}

const mapStateToProps = state => ({
    selectedMealTypes: ProductionReportSetupSelectors.getMealTypes(state),
    details: ProductionReportSetupSelectors.getDetails(state),
    otherDetails: ProductionReportSetupSelectors.getOtherDetails(state),
    reportNotes: ProductionReportSetupSelectors.getReportNotes(state),
});
  
const mapDispatchToProps = {
    setMealType: ProductionReportSetupActions.setMealType,
    setMealTypes: ProductionReportSetupActions.setMealTypes,
    removeMealType: ProductionReportSetupActions.removeMealType,
    setNewReportDetails: ProductionReportSetupActions.setNewReportDetails,
    setNewReportOtherDetails: ProductionReportSetupActions.setNewReportOtherDetails,
    setNewReportNotes: ProductionReportSetupActions.setNewReportNotes,
};

AssignMenuMealTypePage = connect(
    mapStateToProps,
    mapDispatchToProps
)(AssignMenuMealTypePage);

export { AssignMenuMealTypePage };


// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/subpages/AssignMenuMealTypePage.js